<template>
  <div class="h-100 position-absolute root w-100">
    <div class="align-items-center bg-dark bg-opacity-50 d-none fixed-top h-100 justify-content-center loading w-100" ref="loading">
      <Pulse-Loader :loading="loading"></Pulse-Loader>
    </div>

    <b-modal
      :centered="passwordChangeModal.centered"
      :hideHeaderClose="passwordChangeModal.hideHeaderClose"
      :noCloseOnBackdrop="passwordChangeModal.noCloseOnBackdrop"
      :size="passwordChangeModal.size"
      :title="passwordChangeModal.title"

      content-class="user-select-none"
      footer-class="border-0 p-2"
      header-class="bg-light border-bottom px-4 py-3"
      v-model="passwordModal"
    >
      <template #modal-header>
        <div class="align-items-center d-flex">
          <svg height="16" style="fill: #000 !important;" viewBox="0 0 16 16" width="16">
            <path d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2M3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z"/>
          </svg>
          <h5 class="m-0 ms-3">
            Redefini&ccedil;&atilde;o de senha
          </h5>
        </div>
      </template>
      <form @submit.prevent="changePassword()" class="align-items-center d-flex flex-column py-3">
        <input
          class="border border-2 m-0 mb-2 p-3 rounded-2 text-center"
          id="current-password"
          placeholder="Senha atual"
          ref="currentPassword"
          required
          type="password"
        />
        <input
          class="border border-2 m-0 mb-2 p-3 rounded-2 text-center"
          id="new-password"
          placeholder="Nova senha"
          ref="newPassword"
          required
          type="password"
        />
        <input
          class="border border-2 m-0 mb-2 p-3 rounded-2 text-center"
          id="confirm-password"
          placeholder="Confirmação da nova senha"
          ref="confirmPassword"
          required
          type="password"
        />
        <input
          class="border-0 m-0 mb-3 p-3 rounded-2 text-uppercase text-white"
          type="submit"
          value="Atualizar senha"
        />
      </form>
      <template #modal-footer>
        <button class="border-0 btn btn-primary-color btn-sm shadow-none text-white" @click="passwordModal = false;">
          Fechar
        </button>
      </template>
    </b-modal>

    <nav class="fixed-top navbar p-4">
      <div class="container-fluid">
        <div class="ms-auto">
          <button
            :id="this.state.userType"
            
            class="border-0 btn me-3 p-0 shadow-none"
            ref="r_pass"
            title="Redefinir a senha de acesso"

            v-if="this.state.userType != 'Paciente' && !isButtonDisabled"
            v-b-tooltip.hover 

            @click="passwordModal = true;" 
          >
            <svg height="28" viewBox="0 0 330 330" width="28">
              <path d="M65,330h200c8.284,0,15-6.716,15-15V145c0-8.284-6.716-15-15-15h-15V85c0-46.869-38.131-85-85-85S80,38.131,80,85v45H65c-8.284,0-15,6.716-15,15v170C50,323.284,56.716,330,65,330z M180,234.986V255c0,8.284-6.716,15-15,15s-15-6.716-15-15v-20.014c-6.068-4.565-10-11.824-10-19.986c0-13.785,11.215-25,25-25s25,11.215,25,25C190,223.162,186.068,230.421,180,234.986z M110,85c0-30.327,24.673-55,55-55s55,24.673,55,55v45H110V85z"/>
            </svg>
          </button>

          <a
            class="border-0 btn p-0 shadow-none"
            href="./"
            title="Sair"

            v-b-tooltip.hover
            v-on:click="logout"
          >
            <svg height="35" viewBox="0 0 16 16" width="35">
              <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
              <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
            </svg>
          </a>
        </div>
      </div>
    </nav>

    <div class="align-items-center d-flex justify-content-center h-100">
      <div class="justify-content-center row w-100">
        <div class="col-10 col-lg-5 col-md-7 col-xl-3 fadeInDown m-auto p-0 py-5 rounded-3 shadow-lg">
          <div class="fadeIn first mt-4">
            <img alt="Laborat&oacute;rio" class="mb-4 w-50" src="assets/logo.png"/>
          </div>

          <form @submit.prevent="listAtendimentos()">
            <input
              class="border border-2 fadeIn m-0 mb-2 p-3 rounded-2 second text-center"
              id="name"
              name="name"
              placeholder="Nome"
              ref="nomePaciente"
              type="text"

              v-if="this.state.userType !== 'tulPacienteCpf'"
            />

            <div class="align-items-center d-flex gap-3 justify-content-center m-0 mb-2">
              <datepicker
                class="datepicker fadeIn me-1 second z-2"
                lang="pt-br"
                placeholder="Período de"
                ref="dataInicio"
                required
                v-model="dateIni"

                :disabled-start-date="{ to: minDate }"
              ></datepicker>

              <datepicker
                class="datepicker fadeIn ms-1 second z-2"
                lang="pt-br"
                placeholder="Período até"
                ref="dataFinal"
                required
                type="date"
                v-model="dateEnd"

                :disabled-start-date="{ to: minDate }"
              ></datepicker>
            </div>

            <input
              class="border border-2 fadeIn fourth m-0 mb-2 p-3 rounded-2 text-center"
              id="laudo"
              name="laudo"
              placeholder="Laudo"
              ref="nLaudo"
              type="text"
            />

            <select
              class="border-2 fadeIn fifth mb-2 p-3 rounded-1 shadow-0 shadow-none text-center userTypeInput"
              ref="procedencia"
              role="button"

              v-if="(this.state.userType !== 'tulPacienteCpf') && this.state.userType !== 'tulMedico' && this.$signedOnly !== 'true'"
            >
              <option disabled selected value="">
                Proced&ecirc;ncia
              </option>
              <option v-for="origin in origins" :key="origin.id" :value="origin.id">
                {{ origin.descricao }}
              </option>
            </select>

            <select
              class="border-2 fadeIn fifth mb-2 p-3 rounded-1 shadow-0 shadow-none text-center userTypeInput"
              ref="viewing"
              role="button"
            >
              <option selected>
                Todos
              </option>
              <option value="1">
                Visualizados
              </option>
              <option value="0">
                N&atilde;o visualizados
              </option>
            </select>

            <input
              class="border-0 fadeIn m-0 mb-3 p-3 rounded-2 sixth text-uppercase text-white"
              type="submit"
              value="Buscar"
            />

            <div class="col-12 d-block fadeIn seventh mt-3 text-center">
              <small>
                {{ this.$version }}
              </small>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BModal } from "bootstrap-vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueDatepickerUi from "vue-datepicker-ui";
import "vue-datepicker-ui/lib/vuedatepickerui.css";
import axios from "axios";

export default {
  name: "LdFilterCmp",
  components: {
    bmodal: BModal,
    Datepicker: VueDatepickerUi,
    PulseLoader,
  },
  data: () => ({
    origins: [],
    passwordModal: false,
    isButtonDisabled: false,
    loading: false,
    confirmPassword: "",
    currentPassword: "",
    dateEnd: "",
    dateIni: "",
    minDate: null,
    newPassword: "",
    passwordChangeModal: {
        centered: true,
        hideHeaderClose: true,
        noCloseOnBackdrop: true,
        size: "md",
        title: "Redefinição de senha",
      },
  }),
  computed: {
    acoes() {
      return this.$actions;
    },
    laudos() {
      return this.$store.laudos;
    },
    state() {
      return this.$store.state;
    },
  },
  mounted: function () {
    let _this = this;

    const disabledTimestamp = localStorage.getItem(_this.state.id + ".buttonDisabledTimestamp");
    if (disabledTimestamp) {
      const currentTime = new Date().getTime();
      const twoHoursInMilliseconds = 2 * 60 * 60 * 1000;

      if (currentTime - disabledTimestamp < twoHoursInMilliseconds) {
        _this.isButtonDisabled = true;
      }
    }

    if (_this.state.lType === "tulPaciente") {
      _this.acoes.clearAll(_this.state);
      _this.$router.push("/");
    }

    if (_this.state.lType === "tulPacienteCpf") {
      const today = new Date();
      const oneYearAgo = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());

      _this.dateIni = oneYearAgo;
      _this.dateEnd = today;
    } else {
      const today = new Date();
      const oneWeekAgo = new Date(today);
      oneWeekAgo.setDate(today.getDate() - 7);

      _this.dateIni = oneWeekAgo;
      _this.dateEnd = today;
    }

    if (_this.$signedOnly !== "true") {
      _this.getOrigins();
    }

    _this.minDate = _this.$minDate;
  },
  methods: {
    changePassword() {
      let _this = this;

      let confirmPassword = _this.$refs.confirmPassword.value;
      let currentPassword = _this.$refs.currentPassword.value;
      let newPassword = _this.$refs.newPassword.value;
      let tpLogin = _this.state.lType;
      let username = _this.state.user;

      if (currentPassword && confirmPassword && newPassword) {
        if (newPassword !== currentPassword) {
          if (newPassword === confirmPassword) {
            axios.post("v3/senha/redefinir", {
              confirmpassword: confirmPassword,
              currentpassword: currentPassword,
              newpassword: newPassword
            },
            {
              headers: {
                Authorization: `Bearer ${_this.state.token}`
              },
            }).then((response) => {
              _this.$notify({
                group: "alerts",
                text: response.data.message,
                title: "Sucesso",
                type: "success",
              });
            }).catch((error) => {
              _this.$notify({
                group: "alerts",
                text: error.response.data.message,
                title: "Atenção!",
                type: "danger"
              });
            }).finally(() => {
              _this.passwordModal = false;
            });
          } else {
            _this.$notify({
              group: "alerts",
              text: "As senhas não coincidem!",
              title: "Atenção!",
              type: "warn",
            });
          }
        } else {
          _this.$notify({
            group: "alerts",
            text: "A nova senha não pode ser igual à senha anterior!",
            title: "Atenção!",
            type: "warn",
          });
        }
      } else {
        _this.$notify({
          group: "alerts",
          text: "Os dados necessários não foram informados!",
          title: "Atenção!",
          type: "warn",
        });
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    getOrigins() {
      let _this = this;

      axios.get("v3/procedencia/listar")
      .then((response) => {
        _this.origins = response.data;
      }).catch((error) => {
        alert(error);
      });
    },
    handleResponse(userID) {
      const disabledTimestamp = new Date().getTime();
      let _this = this;

      _this.isButtonDisabled = true;
      
      localStorage.setItem(userID + ".buttonDisabledTimestamp", disabledTimestamp);
      setTimeout(() => {
        _this.isButtonDisabled = false;
        localStorage.removeItem(userID + ".buttonDisabledTimestamp");
      }, 2 * 60 * 60 * 1000);
    },
    hideLoading() {
      let _this = this;

      _this.loading = false;
      _this.$refs.loading.classList.add("d-none");
      _this.$refs.loading.classList.remove("d-flex");
    },
    listAtendimentos() {
      let _this = this;

      _this.showLoading();

      var paciente = _this.$refs.nomePaciente != undefined
        ? _this.$refs.nomePaciente.value
        : null;

      var procedencia = _this.$refs.procedencia != undefined
        ? _this.$refs.procedencia.value
        : null;

      var protocolo = _this.$refs.nLaudo != undefined
        ? _this.$refs.nLaudo.value
        : null;

      var visualizado = _this.$refs.viewing != undefined
        ? _this.$refs.viewing.value
        : null;

      axios.get("v3/atendimento/listar", {
        headers: {
          Authorization: `Bearer ${_this.state.token}`
        },
        params: {
          fim: _this.$refs.dataFinal.value || null,
          inicio: _this.$refs.dataInicio.value || null,
          paciente: paciente,
          procedencia: procedencia,
          protocolo: protocolo,
          visualizado: visualizado
        }
      }).then((response) => {
        _this.acoes.setLaudos(response.data);
        _this.$router.push("/list");
      }).catch((error) => {
        _this.$notify({
          group: "alerts",
          text: error.response.data.message,
          title: "Atenção!",
          type: "error"
        });
      }).finally(() => {
        _this.hideLoading();
      });
    },
    async listPatCpfAtends() {
      let _this = this;

      let ac = _this.acoes;

      var filial = 0;
      var hasLaudo = false;

      var dataInicio = _this.$refs.dataInicio.value;
      var dataFinal = _this.$refs.dataFinal.value;
      var nLaudo = _this.$refs.nLaudo.value;

      var password = _this.state.password;
      var tpLogin = _this.state.lType;
      var username = _this.state.user;
      var viewing = null;

      if (dataInicio === "" || dataInicio === undefined || dataFinal === undefined || dataFinal === "") {
        if (nLaudo != "" && nLaudo != undefined) {
          hasLaudo = true;
        } else {
          setTimeout(() => {
            _this.$notify({
              group: "alerts",
              text: "É necessário informar o período de busca.",
              title: "Atenção!",
              type: "warn",
            });
          }, 100);

          return;
        }
      }

      var dti = '';
      var dtf = '';

      if (!hasLaudo) {
        var dtIni = dataInicio;
        
        dti = dtIni.toISOString();
        dti = dti.slice(0, dti.length - 5);
        dti = dti.replace("T", " ");
        dti = dti.split(" ")[0];

        var dtFim = dataFinal;

        dtf = dtFim.toISOString();
        dtf = dtf.slice(0, dtf.length - 5);
        dtf = dtf.replace("T", " ");
        dtf = dtf.split(" ")[0];
      }

      if (_this.$refs.viewing !== undefined) {
        viewing = _this.$refs.viewing.value;
      }

      _this.showLoading();

      if (_this.$signedOnly !== "true" || _this.unsignedAvailable) {
        await axios
        .get(
          "/v1/atendimentos" +
          "?COD104=" +
          filial +
          "&COD106=" +
          tpLogin +
          "&COD101=" +
          username +
          "&COD100=" +
          password +
          "&COD21=" +
          dti +
          "&COD22=" +
          dtf +
          "&COD131=" +
          nLaudo
        )
        .then(function (response) {
          if (response.status === 200) {
            var xml = response.data.msg.Resultado.$value;

            const parser = new DOMParser();
            const doc = parser.parseFromString(xml, "application/xml");
            const errorNode = doc.querySelector("parsererror");

            if (!errorNode) {
              var l = [];
              var listAtends = Array.from(doc.all[0].children);

              if (listAtends.length > 0) {
                for (const el of listAtends) {
                  var idAtend = el.getElementsByTagName("idAtend")[0].textContent;
                  var idFilial = el.getElementsByTagName("idFilial")[0].textContent;
                  var atnAno = el.getElementsByTagName("atnAno")[0].textContent;
                  var idMedReq = el.getElementsByTagName("idMedReq")[0].textContent;
                  var medAbr = el.getElementsByTagName("medAbr")[0].textContent;
                  var medNome = el.getElementsByTagName("medNome")[0].textContent;
                  var pacNome = el.getElementsByTagName("pacNome")[0].textContent;
                  var dtAtend = el.getElementsByTagName("atnDtAtend")[0].textContent;
                  var jaVisto = el.getElementsByTagName("atnJaVisto")[0].textContent;
                  var lstEms = el.getElementsByTagName("listaExames")[0].children;

                  var isValid = false;

                  if (viewing === '' || viewing === undefined) {
                    isValid = true;
                  } else if (viewing === "1" && jaVisto === "True") {
                    isValid = true;
                  } else if (viewing === "0" && jaVisto === "False") {
                    isValid = true;
                  } else {
                    isValid = false;
                  }

                  if (isValid) {
                    var atndhprent = el.getElementsByTagName("atnDhPRent");
                    var dtPrevAtend = atndhprent.length > 0 ? atndhprent[0].textContent : "";

                    var atndhentug = el.getElementsByTagName("atnDhEntUg");
                    var dtEntUg = atndhentug.length > 0 ? atndhentug[0].textContent : "";

                    var atndhvisto = el.getElementsByTagName("atnDhVisto");
                    var dtVisto = atndhvisto.length > 0 ? atndhvisto[0].textContent : "";

                    var dtPrentAtend = null;
                    if (dtPrevAtend != "") {
                      dtPrentAtend = dtPrevAtend;
                    } else {
                      dtPrentAtend = dtEntUg;
                    }

                    if (!el.getElementsByTagName("listaExames").length) {
                      continue;
                    }
                    
                    var atend = idAtend + "." + idFilial + "/" + atnAno.slice(2, 4);
                    var estatus = -1;
                    let lEmsStatus = "";
                    var resLib = -1;
                    var resLibStr = "";

                    for (const ems of lstEms) {
                      lEmsStatus = ems.getElementsByTagName("emsStatus")[0].textContent.replace("tse", "");
                      if (lEmsStatus === "Liberado") {
                        resLibStr = resLibStr + "0";
                      } else {
                        resLibStr = resLibStr + "1";
                      }
                    }

                    if (resLibStr.includes("0")) {
                      estatus = 0;
                      resLib = 0;
                    }

                    if (resLibStr.includes("1")) {
                      if (estatus === 0) {
                        resLib = 1;
                      } else {
                        resLib = 0;
                      }
                    } else {
                      resLib = 2; // totalmente liberado
                    }

                    if (medNome != null) {
                      medNome = medAbr + " " + medNome
                    }

                    var lObj = {
                      dtAtend: dtAtend,
                      dtPrentAtend: dtPrentAtend,
                      dtVisto: dtVisto,
                      atend: atend,
                      pacNome: pacNome,
                      medNome: medNome,
                      idMedReq: idMedReq,
                      req: idMedReq,
                      status: resLib
                    };

                    l.push(lObj);
                  }
                }

                l.sort((start, end) => {
                  const startDate = new Date(start.dtAtend);
                  const endDate = new Date(end.dtAtend);

                  return startDate - endDate;
                });

                l.reverse();

                ac.setLaudos(l);

                if (l.length > 0) {
                  _this.$router.push('/list');
                } else {
                  _this.$notify({
                    group: "alerts",
                    text: "Nenhum resultado foi encontrado para o período ou laudo informado.",
                    title: "Atenção!",
                    type: "error",
                  });
                }
              } else {
                _this.$notify({
                  group: "alerts",
                  text: "Nenhum resultado foi encontrado para o período ou laudo informado.",
                  title: "Atenção!",
                  type: "error",
                });
              }
            }
          }
        })
      } else {
        try {
          await axios
          .get(
            "/v2/atendimento" +
            "?COD106=" +
            tpLogin +
            "&COD101=" +
            username +
            "&COD100=" +
            password +
            "&COD21=" +
            dti +
            "&COD22=" +
            dtf +
            "&COD09=" +
            nLaudo
          )
          .then(function (response) {
            const data = response.data.atendimentos;
            const laudos = [];

            Object.keys(data).forEach(key => {
              const idsmedreq = data[key];

              Object.keys(idsmedreq).forEach(idmedreq => {
                laudos.push({
                  idmedreq,
                  atend: key,
                  dtAtend: idsmedreq[idmedreq].data_atendimento,
                  dtVisto: idsmedreq[idmedreq].data_hora_visualizacao,
                  paciente: idsmedreq[idmedreq].paciente,
                  solicitante: idsmedreq[idmedreq].solicitante,
                  exames: idsmedreq[idmedreq].exames,
                  status: idsmedreq[idmedreq].status
                });
              });
            });

            _this.acoes.setLaudos(laudos);
            _this.$router.push({
              path: "/list",
              query: {
                filial: filial,
                fim: dtf,
                inicio: dti,
                laudo: nLaudo,
                paciente: ''
              }
            });
          });
        } catch (error) {
          _this.$notify({
            group: "alerts",
            text: error.response.data.message,
            title: "Atenção!",
            type: error.response.data.code === "404" ? "warn" : "error"
          });
        }
      }

      _this.hideLoading();
    },
    logout() {
      let _this = this;

      _this.acoes.setToken(_this.state);
      _this.$router.push("./");
    },
    searchLabRes() {
      let _this = this;

      let nomePaciente = _this.$refs.nomePaciente.value;
      let dataInicio = _this.$refs.dataInicio.value;
      let dataFinal = _this.$refs.dataFinal.value;
      let nLaudo = _this.$refs.nLaudo.value;
      let procedencia = null;
      let viewing = null;

      if (_this.$refs.procedencia !== undefined) {
        procedencia = _this.$refs.procedencia.value;
      }

      if (_this.$refs.viewing !== undefined) {
        viewing = _this.$refs.viewing.value;
      }

      var filial = null;

      if (_this.state.lType === "tulCentralAtendimento") {
        filial = _this.state.idd;
      }

      var hasLaudo = false;
      if (dataInicio === "" || dataInicio === undefined || dataFinal === undefined || dataFinal === "") {
        if (nLaudo != "" && nLaudo != undefined) {
          hasLaudo = true;
        } else {
          setTimeout(() => {
            _this.$notify({
              group: "alerts",
              text: "É necessário informar o período de busca.",
              title: "Atenção!",
              type: "warn",
            });
          }, 100);

          return;
        }
      }

      var dti = '';
      var dtf = '';

      if (!hasLaudo) {
        var dtIni = dataInicio;
        
        dti = dtIni.toISOString();
        dti = dti.slice(0, dti.length - 5);
        dti = dti.replace("T", " ");
        dti = dti.split(" ")[0];

        var dtFim = dataFinal;

        dtf = dtFim.toISOString();
        dtf = dtf.slice(0, dtf.length - 5);
        dtf = dtf.replace("T", " ");
        dtf = dtf.split(" ")[0];
      }

      _this.showLoading();

      var ac = _this.acoes;
      
      if (_this.$signedOnly !== "true") {
        axios
        .get(
          "/v1/res" +
            "?COD24=" +
            _this.state.id +
            "&COD106=" +
            _this.state.lType +
            "&COD01=" +
            nomePaciente +
            "&COD21=" +
            dti +
            "&COD22=" +
            dtf +
            "&COD09=" +
            nLaudo +
            "&COD23=" +
            filial +
            "&COD25=" +
            procedencia +
            "&COD27=" +
            viewing
        )
        .then(function (response) {
          if (response.status === 200) {
            var result = response.data.result;

            result.forEach((item) => {
              item.medNome = item.medNome.replace("null", "");

              // Apparently, for JavaScript null is
              // neither null or "null"
            });

            result.reverse();

            ac.setLaudos(response.data.result);
            _this.$router.push("/list");
          } else {
            _this.hideLoading();
          }
        })
        .catch(function (error) {
          setTimeout(() => {
            _this.$notify({
              group: "alerts",
              text: "Nenhum resultado foi encontrado para o período informado.",
              title: "Atenção!",
              type: "error",
            });

            console.error(error);
          }, 100);
        })
        .finally(() => {
          _this.hideLoading();
        });
      } else {
        axios
        .get(
          "/v2/atendimento" +
          "?COD106=" +
          _this.state.lType +
          "&COD01=" +
          nomePaciente +
          "&COD21=" +
          dti +
          "&COD22=" +
          dtf +
          "&COD09=" +
          nLaudo +
          "&COD101=" +
          _this.state.user +
          "&COD100=" +
          _this.state.password
        )
        .then(function (response) {
          const data = response.data.atendimentos;
          const laudos = [];

          Object.keys(data).forEach(key => {
            const idsmedreq = data[key];

            Object.keys(idsmedreq).forEach(idmedreq => {
                laudos.push({
                  idmedreq,
                  atend: key,
                  dtAtend: idsmedreq[idmedreq].data_atendimento,
                  dtVisto: idsmedreq[idmedreq].data_hora_visualizacao,
                  paciente: idsmedreq[idmedreq].paciente,
                  solicitante: idsmedreq[idmedreq].solicitante,
                  exames: idsmedreq[idmedreq].exames,
                  status: idsmedreq[idmedreq].status
                });
              });
          });

          _this.acoes.setLaudos(laudos);
          _this.$router.push({
            path: "/list",
            query: {
              filial: filial,
              fim: dtf,
              inicio: dti,
              laudo: nLaudo,
              origem: procedencia,
              paciente: nomePaciente
            }
          });
        })
        .catch(function () {
          _this.$notify({
            group: "alerts",
            text: "Nenhum atendimento foi encontrado com os filtros informados",
            title: "Atenção!",
            type: "warn"
          });
        })
        .finally(() => {
          _this.hideLoading();
        });
      }
    },
    showLoading() {
      let _this = this;

      _this.loading = true;
      _this.$refs.loading.classList.add("d-flex");
      _this.$refs.loading.classList.remove("d-none");
    }
  }
};
</script>

<style scoped></style>